// 一套白天主题以及一套暗黑主题

export const themes = {
    dayTheme: {
      bodyBackground: "#E1E1E1",
    },
    nightTheme: {
      bodyBackground: "#000000",
    },
};
